import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const SitemapItem = styled.li`
  line-height: 2.25;
`;

export const SitemapLink = styled(Link).attrs({ 'data-test': 'SitemapLink' })`
  color: ${p => p.theme.colors.maybeBlue700};
`;
